import {
  Box,
  Text,
  VStack,
  HStack,
  Flex,
  Avatar,
  Button,
  Icon,
  Grid,
  Tooltip,
} from '@chakra-ui/react'
import {useDispatch, useSelector} from 'react-redux'
import learnPartTwoRequest from '@apis/learn-part-two'
import {useEffect, useState} from 'react'
import {
  updateMessages,
  updateIsShowSampleAnswer,
  updateIsLoadingBot,
  updateAudio,
} from '@redux/learn-part-two/learnPartTwo'
import {CommonColors} from '@utils/CommonStyles'
import {styleByTextTag} from '@utils'
import {ReactComponent as SaveTrueIcon} from '@assets/svgs/save_true.svg'
import {ReactComponent as SaveFalseIcon} from '@assets/svgs/save_false.svg'
import {
  updateIsShowSavePhraseForm,
  updatePhraseToSave,
} from '@redux/shared/shared'
import SavePhraseForm from '@components/SavePhraseForm'
import UserMsg from './UserMsg'
import {ReactComponent as EyeIcon} from '@assets/svgs/eye.svg'
import AvatarDefault from '@assets/images/avatar-msg-part-two.png'

const ChunkingMsg = ({msg}: {msg: any}) => {
  const {phraseToSave} = useSelector((state: any) => state.shared)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isSaveSentence, setIsSaveSentence] = useState<boolean>(false)
  const [isSave, setIsSave] = useState<any>({})
  const dispatch = useDispatch()

  const handleSavePhrase = async (item: any) => {
    dispatch(updateIsShowSavePhraseForm(true))
    dispatch(updatePhraseToSave(item.text_en))
  }

  const handleAfterSuccess = () => {
    setIsSave((pre: any) => ({
      ...pre,
      [phraseToSave.replace(/ /g, '_')]: true,
    }))
  }

  return (
    <>
      <HStack align="start" spacing={4}>
        <Avatar
          src={AvatarDefault}
          size="sm"
          borderRadius={'50%'}
          border={'2px solid #E4E7EC'}
        />
        <VStack
          maxWidth={'80%'}
          align="start"
          spacing={4}
          bg={'white'}
          p={'16px'}
          borderRadius={'12px'}>
          <Text fontWeight={600} fontSize={'16px'}>
            Xem lại câu trả lời của bạn nhé!
          </Text>
          <Box bg="gray.50" p={4} borderRadius="md" w="full">
            <Flex justify="space-between" align="flex-start" gap={4}>
              <Text flex="1" fontSize={'16px'}>
                {msg?.user_answer}
              </Text>
            </Flex>
          </Box>
          {msg?.chunk?.length > 0 && (
            <Text color="gray.500" fontSize={'16px'}>
              Đừng quên lưu các cụm quan trọng bên dưới nhé!
            </Text>
          )}
          <VStack spacing={6} w="full" p={'16px'}>
            {msg?.chunk?.map((item: any, idx: number) => (
              <Flex key={idx} w="full" justify="space-between" align="center">
                <VStack align="start" spacing={0} pr={4}>
                  <Text fontWeight="600" fontSize={'16px'}>
                    {item.text_en}
                  </Text>
                  <Text fontSize={'16px'} color="gray.600">
                    {item.text_vi}
                  </Text>
                </VStack>
                <Button
                  borderColor={'#70BAFF'}
                  variant="outline"
                  color={CommonColors.primary}
                  bg={
                    isSave[item.text_en.replace(/ /g, '_')] || item?.is_saved
                      ? '#D6EBFF'
                      : 'unset'
                  }
                  leftIcon={
                    <Icon
                      as={
                        isSave[item.text_en.replace(/ /g, '_')] ||
                        item?.is_saved
                          ? SaveTrueIcon
                          : SaveFalseIcon
                      }
                      w={'20px'}
                      h={'20px'}
                    />
                  }
                  onClick={() => handleSavePhrase(item)}>
                  {isSave[item.text_en.replace(/ /g, '_')] || item?.is_saved
                    ? 'Đã lưu'
                    : 'Lưu cụm'}
                </Button>
              </Flex>
            ))}
          </VStack>
        </VStack>
      </HStack>
      <SavePhraseForm handleAfterSuccess={handleAfterSuccess} />
    </>
  )
}

export default ChunkingMsg
